import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import { CircularProgress } from "@mui/material";
export const DashboardPageLayout = ({ title, description, actions, children, className })=>{
    const containerClassName = className ? `mx-auto min-h-full w-full max-w-7xl bg-background-1 p-6 ${className}` : "mx-auto min-h-full w-full max-w-7xl bg-background-1 p-6";
    return /*#__PURE__*/ _jsxs("div", {
        className: containerClassName,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mb-6 flex min-w-0 items-center justify-between gap-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "min-w-0",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "text-2xl font-semibold text-gray-900",
                                children: title
                            }),
                            description && /*#__PURE__*/ _jsx("p", {
                                className: "mt-1 text-sm text-gray-500",
                                children: description
                            })
                        ]
                    }),
                    actions
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex w-full min-w-0 flex-col gap-6",
                children: children
            })
        ]
    });
};
export function DashboardPageSection({ children, className, surface = "plain", padding = "none", ...props }) {
    return /*#__PURE__*/ _jsx("section", {
        className: clsx("w-full min-w-0", surface === "card" && "rounded-lg border border-gray-200 bg-white shadow-sm", padding === "default" && "p-4 md:p-6", className),
        ...props,
        children: children
    });
}
export function DashboardPageFilters({ children, className, ...props }) {
    return /*#__PURE__*/ _jsx(DashboardPageSection, {
        className: className,
        ...props,
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex w-full min-w-0 flex-wrap items-end gap-4",
            children: children
        })
    });
}
export function DashboardPageLoading() {
    return /*#__PURE__*/ _jsx(DashboardPageSection, {
        className: "flex h-64 items-center justify-center",
        children: /*#__PURE__*/ _jsx(CircularProgress, {})
    });
}
export default DashboardPageLayout;
